import _ from "lodash";
const getters = {
    getPeopleList: (state) => {
        const sorted = _.orderBy(state.peopleList, ['_ts'], ['asc']);
        let peopleList = sorted.map((people, inc) => {
            const match = state.peopleSortableList.find(p => p.id == people.id);
            let order = inc;
            if(match){
                order = match.displayOrder
            }
            return {...people, displayOrder: order};
        });
          return peopleList;
    },
    getSortedUserList: (state) => {
        const defaultUserList = state.userList.filter(repository => {
            if(repository.is_listed_in_people === true){
                return repository;
              }
            });
        const sorted = _.orderBy(defaultUserList, ['_ts'], ['asc']);
        let userList = sorted.map((people, inc) => {
            const match = state.peopleSortableList.find(p => p.id == people.id);
            let order = inc;
            if(match){
                order = match.displayOrder
            }
            return {...people, displayOrder: order};
        });
          return userList.sort((a, b) => a.displayOrder - b.displayOrder);
    },
    getAdminUserList: (state) => {
        const data = state.userList.filter(repository => {
            if(repository.is_listed_in_people === false){
                return repository;
              }
        });
        return data;
    },
    getPeopleUserList: (state) => {
        const data = state.userList.filter(repository => {
            if(repository.is_registered_user === false){
                return repository;
              }
        });
        return data;
    }
};

export default getters;
